var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('TableBlock')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"title-page"},[_vm._v("Lista de Códigos de Serviços que "),_c('b',[_vm._v("não lançará")]),_vm._v(" no Grupo 4")])
}]

export { render, staticRenderFns }